
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import AppClientPortalPaymentQrSettings from "@/components/settings-sales/ClientPortalPaymentQrSettings.vue";
import AppClientPortalEmailTemplateSettings from "@/components/settings-sales/ClientPortalEmailTemplateSettings.vue";
import AppClientPortalGeneralSettings from "@/components/settings-sales/ClientPortalGeneralSettings.vue";

export default Vue.extend({
	data() {
		return {
			config: DossierConfigService.getPortalConfig()
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales", value: this.$ct("sale/purchase")
				},
				{
					value: this.$ct("client-portal")
				}
			] as IBreadCrumb[];
		}
	},
	methods: {
		save() {
			DossierConfigService.setPortalConfig(this.config);
			this.$wf.notify(this.$ct("template-saved").toString(), "success", 2000);
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppClientPortalPaymentQrSettings,
		AppClientPortalEmailTemplateSettings,
		AppClientPortalGeneralSettings
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
